module.exports = __webpack_public_path__ + "img/greyQues.40c3004e.svg";